import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ReportingPaths } from 'src/components/AppRoutes/Enterprise/ReportingPaths';
import {
  ReportingCreateRoute,
  ReportingManageRoute,
} from 'src/components/AppRoutes/ReportingRoutes.layout';

export const ReportingRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route
        exact
        path={ReportingPaths.create}
        component={ReportingCreateRoute}
      />
      <Route
        exact
        path={ReportingPaths.manage}
        component={ReportingManageRoute}
      />
    </Switch>
  );
};
